import { render } from "./AddExtractionField.vue?vue&type=template&id=4113e326&scoped=true"
import script from "./AddExtractionField.vue?vue&type=script&lang=js"
export * from "./AddExtractionField.vue?vue&type=script&lang=js"

import "./AddExtractionField.vue?vue&type=style&index=0&id=4113e326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4113e326"]])

export default __exports__